import React, { useState } from 'react';
import Sticky from 'react-stickynode';
import { Link } from 'react-router-dom';

import { useConfig } from 'config/ConfigContext';
import FaqOverlay from 'components/FaqOverlay';

import Logo from './Logo';
import NavLink from './NavLink';

const Header = () => {
  const { envLabel } = useConfig();
  const [isFaqOpen, setIsFaqOpen] = useState(false);

  return (
    <>
      <Sticky
        className="z-[350]"
        enabled
        innerZ={20}
      >
        <header className="bg-blue-50 w-full flex justify-between items-center py-4 px-4 sm:px-6">
          <div className="flex items-center gap-3">
            <Link className="h-10 sm:h-8" to="/" reloadDocument>
              <Logo />
            </Link>
            {envLabel && envLabel !== 'production' ? (
              <span className="uppercase leading-none font-semibold text-gray-400 relative top-[3px]">{envLabel}</span>
            ) : null}
          </div>

          <nav className="flex items-center gap-4">
            <NavLink label="Support" to="tel:+18447216961" />
            <div className="w-px h-6 bg-gray-300" />
            <NavLink label="FAQ" onClick={() => setIsFaqOpen(true)} />
          </nav>
        </header>
      </Sticky>

      <FaqOverlay isOpen={isFaqOpen} onClose={() => setIsFaqOpen(false)} />
    </>
  );
};

export default Header;
